import { ALERT, FUTURES } from "../../constants";
import axios from "@helpers/axios/private.axios";

export const PostPosition = (data) => async (dispatch) => {
  try {
    const resp = await axios.post("/futures/positions/store", {
      ...data,
    });

    // The backend returns the row in the shape of /positions/open: show it without waiting for a poll
    dispatch({
      type: FUTURES.POSITION_OPENED,
      payload: { position: resp.data.data, at: Date.now() },
    });

    dispatch({
      type: FUTURES.SHOW_NOTIFICATION,
      payload: { ...resp.data.data, notificationType: "positionOpened" },
    });
    return resp;
  } catch (e) {
    dispatch({
      type: ALERT.ALERT_ERROR,
      payload: e.response?.data?.message,
    });
    throw e;
  }
};
